import Layout from "../../layout/index";
import router from "../routers";
export var eleFence = {
  name: "电子围栏管理",
  path: "/eleFence",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "20",
  sort: 6,
  meta: {
    title: "电子围栏管理",
    icon: "map-outline",
    noCache: false
  },
  children: [{
    name: "电子围栏管理",
    path: "/eleFence",
    hidden: false,
    component: "eleFence/index",
    elemCode: "200",
    meta: {
      title: "电子围栏管理",
      noCache: true
    }
  }]
};

// 新建/详情页不进用户中心菜单，作为隐藏路由单独注册
export var eleFenceRoutes = [{
  path: '/eleFence/countryBoundary',
  component: Layout,
  hidden: true,
  elemCode: '200',
  children: [{
    path: '',
    component: function component(resolve) {
      return require(['@/views/eleFence/countryBoundary'], resolve);
    },
    meta: {
      title: '新建围栏-基于国境线',
      noCache: true
    }
  }]
}, {
  path: '/eleFence/manualDraw',
  component: Layout,
  hidden: true,
  elemCode: '200',
  children: [{
    path: '',
    component: function component(resolve) {
      return require(['@/views/eleFence/manualDraw'], resolve);
    },
    meta: {
      title: '手动绘制围栏',
      noCache: true
    }
  }]
}, {
  path: '/eleFence/detail',
  component: Layout,
  hidden: true,
  elemCode: '200',
  children: [{
    path: '',
    component: function component(resolve) {
      return require(['@/views/eleFence/detail'], resolve);
    },
    meta: {
      title: '围栏详情',
      noCache: true
    }
  }]
}];
router.addRoutes(eleFenceRoutes);